<div class="layoutBlock">
    <div class="columnThreeQuarter">

        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>

        <res-classifications-tab
        	[(subjectAreas)]="publication.subjectAreas"
            [(researchAreas)]="publication.researchAreas"
            [(researchAreasKdsf)]="publication.researchAreasKdsf"
        	[hisDynamicContent]="'fs.res.common.classifications'"
        	[dynamicComponent]="publication._dynamicComponent"
        	subjectAreaDdKey="fs.res.publication.Publication.subjectAreas"
            researchAreaDdKey="fs.res.publication.Publication.researchAreas"
            researchAreaKdsfDdKey="fs.res.publication.Publication.researchAreasKdsf"
            [changeRequest]="publication.changeRequest"
            [changeRequestValueGroup]="changeRequestValueGroup">
        </res-classifications-tab>

        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>

    </div>
</div>
